module.exports = __webpack_public_path__ + "img/sug4.38e3148d.png";